$('.newsletter-link a').attr('data-bs-toggle', 'modal');
$('.newsletter-link a').attr('data-bs-target', '#newsletter');
